import axios from 'axios';

const API_URL = window.env.API_URL;
const ACCESS_TOKEN = window.env.ACCESS_TOKEN;

const authHeaders = () => ({
  Authorization: `Bearer ${window.localStorage.getItem(ACCESS_TOKEN)}`,
});

/**
 * Building / ArqFinishes: set need_case file links from uploaded file UUIDs.
 * PUT /warranties/:code/end-user-case-study-file — body matches UpdateWarrantyFilesRequest (e.g. fileUUIDs).
 */
export function putEndUserCaseStudyFile(code, fileUUIDs) {
  return axios.put(
    `${API_URL}/warranties/${encodeURIComponent(
      code,
    )}/end-user-case-study-file`,
    { fileUUIDs },
    { headers: authHeaders() },
  );
}

/**
 * Building / ArqFinishes: set glass checklist file links from uploaded file UUIDs.
 * PUT /warranties/:code/glass-check-file
 */
export function putGlassCheckFile(code, fileUUIDs) {
  return axios.put(
    `${API_URL}/warranties/${encodeURIComponent(code)}/glass-check-file`,
    { fileUUIDs },
    { headers: authHeaders() },
  );
}
